import { SmartComponent } from "smart-component-js";
import Swiper, { Navigation, Pagination } from "swiper";

class SingleCarouselLandingComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.init();
  }

  init() {
    if (typeof Swiper === "undefined") {
      console.error(
        "Swiper non è definito. Assicurati di aver importato Swiper JS."
      );
      return;
    }

    const swiperContainer = this.element.querySelector(
      ".single-carousel__container"
    );

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: ".single-carousel__button--next",
        prevEl: ".single-carousel__button--prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
      },
    });
  }
}

export default SingleCarouselLandingComponent;
